export default {
  setApprovementStatus(state, approvementStatus) {
    state.approvementStatus = approvementStatus;
  },
};
